import axios from "axios";
import { toast } from "react-toastify";

const setupAxiosInterceptors = () => {
  axios.interceptors.response.use(
    (response) => {
      if (response && response.data?.error_code === 463) {
        localStorage.clear();
        setTimeout(() => {
          window.location.href = "/login";
        }, 3000); // Delay for toast visibility
      } else if (response?.data?.error_code === 464) {
        localStorage.clear();
        setTimeout(() => {
          window.location.href = "/login";
        }, 3000);
      } else {
        console.log(response);
      }

      return response;
    },
    (error) => {
      const errorCode = error?.response?.data?.error_code;

      if (errorCode === 463) {
        localStorage.clear();
        toast.error("Session expired. Redirecting to login...");
        setTimeout(() => {
          window.location.href = "/login";
        }, 3000);
      } else if (errorCode === 464) {
        localStorage.clear();
        setTimeout(() => {
          window.location.href = "/login";
        }, 3000);
      } else {
        console.error(error);
      }

      return Promise.reject(error);
    }
  );
};

export default setupAxiosInterceptors;
